import React from "react";
import _ from "lodash";
import DoneButton from "./DoneButton";
import autoBind from "react-autobind";
import FontAwesome from "react-fontawesome";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getLabel1Color, getLabel2Color } from "../../utils/entityUtils";

class PlayerSketchpad extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}


	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(); }
	}

	renderReadOnly() {

		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex } = this.props;

		let imgUrl;

		if (item.hasOwnProperty("sketchPadImage") && item.sketchPadImage !== null && item.sketchPadImage !== "") {
			imgUrl = "<p><b>Sketch</b><br/><a href='" + item.sketchPadImage + "' target='blank'><img style='width: 30%; border: 1px solid #eeeeee' src='" + item.sketchPadImage + "' /></a></p>";
		} else {
			imgUrl = "<p><b>Sketch</b><br/>No sketch added.</p>";
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const textStyles = _.pick(styleLabel1, ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
		const textStylesLabel2 = _.pick(styleLabel2, ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "auto" }}>
					<div style={_.assign({},{ color: getLabel1Color(item) }, textStyles)} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={_.assign({}, { color: getLabel2Color(item) }, textStylesLabel2)} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div dangerouslySetInnerHTML={markdownToHtml(imgUrl)} />
				</div>
			</div>;

		return component;
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex, disabled } = this.props;

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const textStyles = _.pick(styleLabel1, ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
		const textStylesLabel2 = _.pick(styleLabel2, ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "auto" }}>
					<div style={_.assign({}, { color: getLabel1Color(item) }, textStyles)} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={_.assign({}, { color: getLabel2Color(item) }, textStylesLabel2)} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<FontAwesome name="exclamation-triangle"/> Editing of sketches is currently not supported in the web player.

					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>;

		return component;
	}
}

export default withPlayerItemHoc(PlayerSketchpad);